module.exports = __webpack_public_path__ + "static/img/our-people-our-investment-full-img.4d2ca6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-our-investment-full-img.jpg
// module id = cmvp
// module chunks = 0